// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import { coreRoutes } from "./core/index";
import { anRoutes } from '@/router/business/an/index'
import { websiteRoutes } from '@/router/business/website/index'
import { zy580Routes } from '@/router/business/zy580/index'
import { $ScaeiService } from "@scaei/service";
import { $ScaeiUtils } from "@scaei/utils";
import getConfig from "@/utils/getConfig";

const baseRoutes = [
  {
    path: "/",
    name: "root",
    redirect: { name: "home" },
  },
  {
    path: "/login",
    name: "login",
    component:  () =>import("@/view/LoginView.vue"),
    meta: {
      keepAlive: true,
      hasNav: false,
      allowAnonymous: true,
    },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/components/HelloWorld.vue"),
    meta: {
      keepAlive: true,
      hasNav: true,
    },
  },
  {
    path: "/wechat/authorize",
    name: "wechat_authorize",
    component: () => import("@/view/LoginWxView.vue"),
    meta: {
      keepAlive: true,
      hasNav: false,
      allowAnonymous: true,
    },
  },
  {
    path: '/updateInitialPwd',
    name: "updateInitialPwd",
    component: () => import('@/view/core/common/sys/UpdateInitialpwd.vue'),
    meta: {
      keepAlive: true,
      hasNav: false,
      allowAnonymous: false
    }
  },
];
const routes = [...baseRoutes, ...coreRoutes,...anRoutes,...websiteRoutes,...zy580Routes];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

let redirecting = false; // 添加标志位

router.beforeEach(async (to, from) => {
  // 登录页跳过
  if (to.meta.allowAnonymous) {
    return true;
  }

  try {
    // 登录检查
    const token = await $ScaeiService.restoreAuthToken();

    if (!token.accessToken) {
      throw { msg: "登录令牌被清除！" };
    }

    if (redirecting) return; // 检查是否正在重定向
    redirecting = true; // 设置标志位

    if(from.name === 'login'|| from.name === 'updateInitialPwd' ||from.name === undefined) {
      var user = await $ScaeiService.getUser(getConfig(),true);
      // 初始密码检查
      if (user.isInitialPassword && to.name != 'updateInitialPwd') {
        return { name: 'updateInitialPwd' };
      }
    }
    redirecting = false; // 重置标志位
  } catch (e) {
    // 直接输入域名不报错
    if (from.name) {
      $ScaeiUtils.showDanger(`登录超时，请重新登录！内部原因：${e.msg}`);
    }
    return { name: "login" };
  }
});



export default router;
